import React, { useContext, useEffect } from "react";
import {
  Paper,
  Text,
  Flex,
  Container,
  Group,
  ActionIcon,
  Image,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useNavigate, useLocation } from "react-router-dom";
import {
  IconAlertCircle,
  IconArrowLeft,
  IconShieldCheck,
  IconX,
} from "@tabler/icons-react";
import { DataContext } from "../context/DataContext";

export default function Navigation({ logo_url }) {
  const context = useContext(DataContext);
  const navigate = useNavigate();
  const isIframe = window !== parent;
  const isWideViewport = useMediaQuery("(min-width: 600px)");

  // Only destructure if context is available
  const dispatch = context?.dispatch;
  const settings = context?.settings;
  const currentPath = context?.currentPath;
  const postMessage = context?.postMessage;

  // Determine if close button should be shown
  // Default behavior: show X if in iframe
  // Override: if isCloseButtonShown exists and is false, don't show even if in iframe
  const shouldHideCloseButton = settings?.isCloseButtonShown === false;

  // Only show X in nav for narrow viewports; wide viewports render it in App.js outside the box
  const showCloseInNav = isIframe && !shouldHideCloseButton && !isWideViewport;

  const handleClose = () => {
    if (dispatch) {
      dispatch({ type: "SET_CLOSED_CLICKED", payload: true });
    }
    postMessage && postMessage("CLOSE");
  };

  const handleBack = () => {
    if (dispatch) {
      dispatch({ type: "SET_SELECTED_COMPONENT", payload: "" });
    }
    navigate(-1);
  };

  return (
    <Group
      position={!logo_url ? "right" : "apart"}
      style={{
        height: "30px",
        minHeight: "30px",
        width: "100%",
        ...(showCloseInNav ? { borderBottom: "1px solid #ccc", paddingBottom: "8px", marginLeft: "-25px", marginRight: "-25px", paddingLeft: "25px", paddingRight: "25px", width: "calc(100% + 50px)" } : {}),
      }}
    >
      {logo_url && <Image src={logo_url} width={50} />}

      {showCloseInNav && (
        <ActionIcon variant="light" onClick={handleClose}>
          <IconX stroke={1.5} size={18} />
        </ActionIcon>
      )}
    </Group>
  );
}
